document.addEventListener("DOMContentLoaded", function () {
	var offcanvasLinks = document.querySelectorAll("#offcanvasMenuMobile #mobileNavbarMain a");

	offcanvasLinks.forEach(function (link) {
		link.addEventListener("click", function (event) {
			if (this.hash !== "") {
				if (this.pathname === window.location.pathname) {
					event.preventDefault();

					var offcanvasElement = this.closest(".offcanvas");
					var offcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement);

					var targetId = this.hash.substring(1);
					var targetElement = document.getElementById(targetId);

					if (offcanvas && targetElement) {
						offcanvasElement.addEventListener("hidden.bs.offcanvas", function onOffcanvasHidden() {
							targetElement.scrollIntoView({
								behavior: "smooth",
							});
							window.history.pushState(null, null, "#" + targetId);
							offcanvasElement.removeEventListener("hidden.bs.offcanvas", onOffcanvasHidden);
						});
						offcanvas.hide();
					}
				}
			}
		});
	});
});
